<template>
<div class="component-root">
	<div class="content_retix enedis-consent-form-view">
	<div class="container-retix">
		<div class="bloc_content">
			<h1 class="page-titre">Demande de consentement Enedis</h1>
			<div class="form-columns">				
                <!-- Colonne Gauche -->
				<b-form @submit.prevent="onSubmit"  class="form-column consent-form">
                
					<h3>Informations</h3>
					<b-form-group id="consent-input-group-description" class="bloc_form">
                        <label>Description : (obligatoire)</label>
                        <b-form-input v-model="consent.description" name="description" maxlength="255" required class="input_form"></b-form-input>
						<div class="field-description">Ce champ est informatif, utilisé pour distinguer les demandes.<br/>
							 Il n'est pas visible par le consommateur.</div><!-- field-description -->
                    </b-form-group>
					
					<b-form-group id="consent-input-group-duration" class="bloc_form">
                        <label>Durée : (en mois, obligatoire)</label>
                        <b-form-input v-model="consent.durationMonth" name="duration" :readonly="consent.startDatetime" required class="input_form"></b-form-input>
						<div class="field-description">Les consentements Enedis sont limités dans le temps. <br/>
							Maximum : 36 mois / 3 ans.<br/>Pas de minimum.<br/>
							<span style="color:var(--bleu);">La durée du consentement ne peut pas être changée après que le consommateur aie commencé la démarche sur le site d'Enedis</span>
						</div><!-- field-description -->
                    </b-form-group>
					
					<b-form-group id="consent-input-group-information-message" class="bloc_form">
                        <label>Message d'information : (facultatif)</label>
                        <b-form-textarea v-model="consent.informationMessage" name="information_message" class="input_form consent-information-message" 
						rows="8" max-rows="20"></b-form-textarea>
						<div class="field-description">Texte de personalisation <span class="field-description-important">affiché au consommateur</span>.</div><!-- field-description -->
                    </b-form-group>
				
				<b-form-group id="consent-input-group-email" class="bloc_form">
                    <label>E-mail : (facultatif)</label>
                    <b-form-input v-model="consent.email" name="email"  class="input_form"></b-form-input>
					<div class="field-description">Ce champ est informatif, utilisé pour distinguer les demandes, et pour le bouton « Envoyer par e-mail au client » ci-contre.<br/>
						 Il n'est pas visible par le consommateur.</div><!-- field-description -->
                </b-form-group>

				<!-- plus de choix du portail (13/10/2026) : Data Connect n'existe que sur l'espace Particulier d'Enedis -->

				<button type="submit" class="save-consent btn-jaune" :disabled="submissionOngoing">Enregistrer</button>
				
			</b-form><!-- class="form-column" Colonne Gauche -->
				
				<div class="vertical-separator"></div>
				
				<!-- Colonne Droite -->
                <div class="form-column">
					
					<h3>État</h3>
					
					<div>
						
						<span class="enedis-consent-status-badge" :class="{ 'badge-hachure': statusData.hachure }" :style="{'--badge-color':statusData.color}">{{statusData.text}}</span>  {{statusData.textLong}}
					</div>
					
					<h3>Lien à transmettre</h3>
					
					<span v-if="!consent.id">Le lien n'est disponible qu'après l'enregistrement.</span>
					
					<b-form-group v-if="consent.id" class="bloc_form ">
						<label>Lien :</label>
						<b-form-input v-model="startLink" readonly class="input_form"></b-form-input>
						<a :href="startLink" target="_blank">Voir</a>
					</b-form-group>
					
					<b-button v-if="mailtoLink" :href="mailtoLink" variant="info" ><i class="fa fa-solid fa-envelope-o mr-3"></i>Envoyer par e-mail au client</b-button>
					<!-- message mis en forme avec un lien cliquable, à coller dans l'e-mail (13/10/2026) -->
					<b-button v-if="mailtoLink" variant="outline-info" class="ml-2" @click="copierMessage">{{ messageCopie ? 'Message copié ✓' : 'Copier le message' }}</b-button>
					
					<canvas :id="qrcodeCanvasId" class="qr-code-canvas"></canvas>
					

					<h3>Chronologie</h3>
					
					<table>
						<tr>
							<td>Création de la demande :</td>
							<td>
								<div v-if="consent.creationDatetime">{{formatDate(consent.creationDatetime)}}</div>
								<div v-if="!consent.creationDatetime">—</div>
								<div v-if="consent.creationUser"> par 
									{{formatUser(consent.creationUser)}}
								</div>
							</td>
						</tr>
						<tr>
							<td>Visite sur la page de présentation :</td>
							<td>
								<span v-if="consent.viewDatetime">{{formatDate(consent.viewDatetime)}}</span>
								<span v-if="!consent.viewDatetime">—</span>
							</td>
						</tr>
						<tr>
							<td>Démarrage de la procédure :</td>
							<td>
								<span v-if="consent.startDatetime">{{formatDate(consent.startDatetime)}}</span>
								<span v-if="!consent.startDatetime">—</span>
							</td>
						</tr>
						<tr>
							<td>Date de réception de l'autorisation :</td>
							<td>
								<span v-if="consent.authorizationDatetime">{{formatDate(consent.authorizationDatetime)}}</span>
								<span v-if="!consent.authorizationDatetime">—</span>
							</td>
						</tr>
						<br>
						<tr>
							<td>Liste des PRM :</td>
							<td>
								<span class="prm" v-for="prm in consent.prmList" :key="prm.index" >{{prm}}<br></span>
								<span v-if="!consent.prmList">—</span>
							</td>
						</tr>
					</table>
				</div><!-- class="form-columns" Colonne Droite-->
				
				
				
			
			</div><!-- class="form-columns" -->
		</div><!-- class="bloc_content" -->
	</div><!-- class="container-retix" -->
	</div><!-- class="content_retix enedis-consent-form-view" -->

</div><!-- class="component-root" -->
</template>
<style scoped>
/**
avec
*/
.qr-code-canvas {
	/**/
	width:196px;
	align-self:center;
	/*height:392px;*/
	
}

.save-consent {
	align-self:center;
	
} 

.field-description {
	padding-left:3em;
	font-size:.9rem;
	color:#666;
}

.field-description-important {
	font-weight:bold;
	color:var(--danger)
}

textarea.consent-information-message {
	/* texte vu par le client : encadré discret (13/10/2026 ; fond jaune vif auparavant) */
	border-left:4px solid #f5c518 !important;
	color:#333;
}
.page-titre { font-size:24px; font-weight:800; color:#1a1a2e; margin:0 0 8px; text-align:left; }
.btn-jaune { display:inline-block; padding:10px 28px; border:0; border-radius:22px; background:#f5c518; color:#1a1a2e; font-weight:700; font-size:14px; cursor:pointer; }
.btn-jaune:hover:not(:disabled) { background:#e6b800; }
.btn-jaune:disabled { opacity:.5; cursor:default; }

.enedis-consent-status-badge {
	
}

</style>
<script>
import {enedisConsentService} from '../services/enedisConsent';
import { authenticationService } from '../services/authentication';
import { lienDemarrage, mailtoConsentement, copierMessageConsentement } from '../utils/mailConsentement';
import { etatDuConsentement, etatConsentement } from '../utils/etatConsentement';
import qrcode from 'qrcode' 
import utils  from '../utils/util.ts'
import Vue from 'vue';

export default {

	props:	{
	},//props:	{
	
	data(){
		return {
			uuid:crypto.randomUUID(),
			mode:'CREATE',
			submissionOngoing:false,
			demandId:null,
			consent:{
				description:"",
				email:"",
				informationMessage:"",
				durationMonth:"3",
				portailType:"particulier",
			},
			startLink:null,
			mailtoLink:null,
			messageCopie:false,
			qrcodeCanvasId:null,
			statusData : utils.enedisConsentStatusStringToObject("VOID")
		};
	},//data(){
	
	mounted() {
		this.qrcodeCanvasId = "enedis-start-link-qr-code-canvas-"+this.uuid
		if(this.$route.name ==='enedis-consent-new'){ 
			this.mode = 'CREATE'
			this.demandId = null
			// ouverte depuis la Step 3 : pré-remplie avec le client de l'étude (12/10/2026)
			var q = this.$route.query || {}
			if (q.description) this.consent.description = q.description
			if (q.email) this.consent.email = q.email
		}else{
			this.mode = 'UPDATE'
			this.demandId = this.$route.query.id
			this.getDemand()
		}
	},// mounted() {
		
		
	methods : {
		getDemand(){
			let promise = null
			if(this.demandId){
				promise	= enedisConsentService.getById(this.demandId)
			}else if(this.demandCode){
				promise	= enedisConsentService.getByCode(this.demandCode)
			}
			let successHandler = this.getDemandSuccess.bind(this)
			let errorHandler = this.restError.bind(this)
			promise.then(successHandler).catch(errorHandler)
		},//getDemand()
		
		getDemandSuccess(response){ 
			
			this.consent = response.data
			
			let link = window.location.origin
			link = link.replace(/\/$/,'')
			this.startLink = lienDemarrage(this.consent.code)
			
			// e-mail selon l'agence de l'auteur de la demande (12/10/2026)
			let agence = (this.consent.creationUser && this.consent.creationUser.agence) || authenticationService.getAgence() || ''
			this.mailtoLink = mailtoConsentement(this.consent.email, this.startLink, agence)
			let qrCodeParams = {
				errorCorrectionLevel: 'H',
				scale:16
			}
			// avec ces paramètres, le résultat fait 784 x 784
			// on peut l'afficher proprement en 49, 98, 196, 392
			
			//let qrCode = 
			let canvas = document.getElementById(this.qrcodeCanvasId)
			qrcode.toCanvas(canvas, this.startLink,qrCodeParams)
			canvas.style = "" 
			
			this.statusData = etatConsentement(etatDuConsentement(this.consent), this.consent)
			
		},//getDemandSuccess(){ 


		async copierMessage(){
			try {
				let agence = (this.consent.creationUser && this.consent.creationUser.agence) || authenticationService.getAgence() || ''
				await copierMessageConsentement(this.startLink, agence)
				this.messageCopie = true
			} catch (e) {
				Vue.toasted.error("Le message n'a pas pu être copié : copiez le lien ci-dessus.")
			}
		},

		restError(error){
			let errorMessage = error.response.data.exception.message
			if(errorMessage)
				Vue.toasted.error(errorMessage);
			else
				Vue.toasted.error(error);
			this.submissionOngoing = false
		},//restError(){
		
			
		formatDate(dateString) {
            if (!dateString) return "-";
            const date = new Date(dateString);
            return date.toLocaleString();
        },// formatDate(dateString)
		
		formatUser(user){
			
			if(utils.stringIsBlank(user.firstname) && utils.stringIsBlank(user.lastname))
				return user.email
			
			return user.firstname+" "+user.lastname
		},//formatUser(user){
			
		onSubmit(){
			if(this.mode === 'CREATE'){ 
				this.createDemand()
			}else{
				this.updateDemand()
			}
		},// onSubmit(){
			
		//submissionOngoing
		createDemand(){
			this.submissionOngoing = true
			let createPromise = enedisConsentService.create(this.consent)
			let successHandler = this.createDemandSuccess.bind(this)
			let errorHandler = this.restError.bind(this)
			createPromise.then(successHandler).catch(errorHandler)
		},//createDemand(){
		
		createDemandSuccess(response){
			this.mode = 'UPDATE'
			this.getDemandSuccess(response)
			this.submissionOngoing = false
			Vue.toasted.success("Demande de consentement enregistrée.");
		},//createDemandSuccess(){
		
		
			
		updateDemand(){
			this.submissionOngoing = true
			let updatePromise = enedisConsentService.update(this.consent)
			let successHandler = this.updateDemandSuccess.bind(this)
			let errorHandler = this.restError.bind(this)
			updatePromise.then(successHandler).catch(errorHandler)
		},//updateDemand(){
			
		updateDemandSuccess(response){
			this.submissionOngoing = false
			this.consent = response.data
			Vue.toasted.success("Demande de consentement mise à jour.");
		},//updateDemandSuccess(){
			
		
	},//methods: {
}
</script>
